module.exports = __webpack_public_path__ + "static/media/coaching-for-a-specific-issue.b0c901fb.svg";